import WorkoutsMedia from './WorkoutsMedia';

export default WorkoutsMedia;
